const createAuthFlowError = <TError extends Error & { code?: string }>(
    message: string,
    code?: string,
): TError => {
    const flowError = new Error(message) as TError;
    flowError.code = code;
    return flowError;
};

export default createAuthFlowError;
